'use client';

import { useRef, useState, useEffect, useId } from 'react';
import { YouTubeEmbed } from '@next/third-parties/google';

import { Title } from '../../title';
import { YoutubeCover } from '../../youtube-cover';
import { getYouTubeId } from 'services/lib/util';

const AcfDayPremiere = ({ data }) => {
  const nativePlayerRef = useRef(null);
  const [isActive, setIsActive] = useState(false);
  const videoId = useId();

  const dayPremiere = data?.dayPremiere;

  useEffect(() => {
    const handlePause = (event) => {
      if (event.detail?.playingVideoId !== videoId && nativePlayerRef.current) {
        if (typeof nativePlayerRef.current.pause === 'function') {
          nativePlayerRef.current.pause();
        }
      }
    };

    window.addEventListener('pauseAllVideos', handlePause);
    return () => window.removeEventListener('pauseAllVideos', handlePause);
  }, [videoId]);

  const broadcastPlay = () => {
    window.dispatchEvent(new CustomEvent('pauseAllVideos', { detail: { playingVideoId: videoId } }));
  };

  const handleNativeClick = () => {
    setIsActive((current) => !current);
    broadcastPlay();
    if (nativePlayerRef.current && typeof nativePlayerRef.current.play === 'function') {
      nativePlayerRef.current.play();
    }
  };

  if (!dayPremiere) {
    return null;
  }

  const externalId = dayPremiere.videoExternal ? getYouTubeId(dayPremiere.videoExternal) : null;
  const mediaItemUrl = dayPremiere.video?.node?.mediaItemUrl;
  const imageNode = dayPremiere.image?.node;

  return (
    <section className="dayPremiereBlock w-full px-0">
      <Title text={dayPremiere.title || 'Premiera Dnia'} className="mb-4 px-0 xmd:mb-6" />

      <div className="columnsWrapper flex w-full flex-wrap px-0">
        <div className="image w-full px-0 sm:w-1/2">
          {externalId ? (
            <div className="videoWrapper w-full px-0">
              <YouTubeEmbed videoid={externalId} params="modestbranding=1&rel=0" />
            </div>
          ) : mediaItemUrl ? (
            <div className="videoWrapper relative w-full px-0">
              {imageNode?.sourceUrl && (
                <YoutubeCover
                  coverImage={imageNode.sourceUrl}
                  alt={imageNode.title}
                  title={imageNode.title}
                  handleClick={handleNativeClick}
                  isActive={isActive}
                />
              )}
              <video
                ref={nativePlayerRef}
                className="youtubeVideo w-full px-0"
                controls
                poster={imageNode?.sourceUrl}
                onPlay={broadcastPlay}
              >
                <source src={mediaItemUrl} type="video/mp4" />
                Twoja przeglądarka nie wspiera odtwarzacza wideo.
              </video>
            </div>
          ) : (
            <div className="flex aspect-video w-full items-center justify-center bg-[#242424] text-white px-0">
              Brak wideo
            </div>
          )}
        </div>

        <div className="description w-full px-0 sm:w-1/2 sm:pl-6">
          <Title
            variant="h3"
            link={dayPremiere.link?.url}
            text={dayPremiere.rightTitle}
            className="mb-4 text-[22px] leading-[26px] px-0 xmd:mb-5 xmd:text-[26px] xmd:leading-[30px]"
          />
          {dayPremiere.description && (
            <p className="content m-0 text-[1rem] leading-[1.5] text-secondary px-0">{dayPremiere.description}</p>
          )}
        </div>
      </div>
    </section>
  );
};

export default AcfDayPremiere;
